export const getUnit = (filterInputType: string) => {
	switch (filterInputType) {
		case "Quantity in kg":
			return "quantityInKg";
		default:
		case "Euros":
			return "valueInEuros";
	}
};
